import { render, staticRenderFns } from "./RoomScheduleTab.vue?vue&type=template&id=aea83870&scoped=true&lang=pug"
import script from "./RoomScheduleTab.vue?vue&type=script&lang=ts"
export * from "./RoomScheduleTab.vue?vue&type=script&lang=ts"
import style0 from "./RoomScheduleTab.vue?vue&type=style&index=0&id=aea83870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea83870",
  null
  
)

export default component.exports